module.exports = "images/delete.f7d74f99d16862fb4d02872778368df3.png";